module.exports = __webpack_public_path__ + "static/img/folia.5175bb29.webp";